import useKurlypay, { KURLYPAY_PAGES, KurlypayPage } from '../../../shared/hooks/useKurlypay';
import { KURLYPAY_PATH } from '../../../shared/constant';
import { BADGE_KEY, updateReadBadge } from '../../../shared/api';

export const useCheckKurlyPay = () => {
  const { openKurlypayPage, getReturnUrl } = useKurlypay();

  const handleCheckKurlyPay = async (title: string) => {
    const isKurlyPay = title === '컬리페이 관리';
    if (isKurlyPay) {
      const pageParams: { page: KurlypayPage; returnUrl: string } = {
        page: KURLYPAY_PAGES.mypage,
        returnUrl: getReturnUrl(`${KURLYPAY_PATH.kurlypayDefaultCallback.uri}`),
      };
      await openKurlypayPage(pageParams);
      await updateReadBadge(BADGE_KEY.kurlypay_badge);
      return true;
    }
  };

  return { handleCheckKurlyPay };
};
